<template>
    <VACButton @click="backToTop" icon="full-arrow-up" appearance="secondary" />
</template>
<script setup>
import VACButton from './VACButton.vue';

const backToTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'})
}
</script>